<div class="video-player">
    <video controls autoplay="true">
        <source [src]="src" type="video/mp4">
        Il tuo browser non supporta i video.
    </video>
</div>